module.exports = __webpack_public_path__ + "static/media/canari_logo_work.d5a887c7.png";